var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgScanIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 49,
    viewBox: "0 0 49 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.74365 18.3822V13.4417C4.74365 8.52097 8.7158 4.54883 13.6365 4.54883H18.577",
    stroke: "#292D32",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M30.4338 4.54883H35.3743C40.295 4.54883 44.2672 8.52097 44.2672 13.4417V18.3822",
    stroke: "#292D32",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M44.2671 32.2158V35.1801C44.2671 40.1008 40.2949 44.073 35.3742 44.073H32.4099",
    stroke: "#292D32",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M18.577 44.0731H13.6365C8.7158 44.0731 4.74365 40.1009 4.74365 35.1802V30.2397",
    stroke: "#292D32",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M21.5409 14.4301V18.3825C21.5409 20.3587 20.5528 21.3468 18.5766 21.3468H14.6242C12.648 21.3468 11.6599 20.3587 11.6599 18.3825V14.4301C11.6599 12.4539 12.648 11.4658 14.6242 11.4658H18.5766C20.5528 11.4658 21.5409 12.4539 21.5409 14.4301Z",
    stroke: "#292D32",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M37.3507 14.4301V18.3825C37.3507 20.3587 36.3626 21.3468 34.3864 21.3468H30.434C28.4578 21.3468 27.4697 20.3587 27.4697 18.3825V14.4301C27.4697 12.4539 28.4578 11.4658 30.434 11.4658H34.3864C36.3626 11.4658 37.3507 12.4539 37.3507 14.4301Z",
    stroke: "#292D32",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M21.5409 30.2397V34.1921C21.5409 36.1682 20.5528 37.1563 18.5766 37.1563H14.6242C12.648 37.1563 11.6599 36.1682 11.6599 34.1921V30.2397C11.6599 28.2635 12.648 27.2754 14.6242 27.2754H18.5766C20.5528 27.2754 21.5409 28.2635 21.5409 30.2397Z",
    stroke: "#292D32",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M37.3507 30.2397V34.1921C37.3507 36.1682 36.3626 37.1563 34.3864 37.1563H30.434C28.4578 37.1563 27.4697 36.1682 27.4697 34.1921V30.2397C27.4697 28.2635 28.4578 27.2754 30.434 27.2754H34.3864C36.3626 27.2754 37.3507 28.2635 37.3507 30.2397Z",
    stroke: "#292D32",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgScanIcon);
export default __webpack_public_path__ + "static/media/scan-icon.a830a5c9f7ccafbb5724f5d5b0809a0c.svg";
export { ForwardRef as ReactComponent };